import { CryptoMsg } from "../models/app/CryptoMsg";
import { IMChat } from "../models/api/IMChat";
import { MqttBroadcast } from "../models/app/MqttBroadcast";
import { MqttMsg } from "../models/app/MqttMsg";
import { MqttMsgType } from "../models/app/MqttMsgType";
import AppCrypto from "./CryptoService";
import { SHA1 } from "./hashFunctions";
import IMChatService from "./IMChatService";
import LocalStorageService from "./LocalStorageService";
import Logger from "./Logger";
import PubKeyManagerService from "./PubKeyManagerService";

class MqttMsgHandlerService{

    

    imChatHandler?: (msg:IMChat)=>void

    constructor(){
        
    }

    handleMqttMsg(msg: string){
        //const decryptedMsg = this.cryptoService.decrypt(msg)
        let msgObj
        try {
            msgObj = JSON.parse(msg)
            switch(msgObj['type']){
                case MqttMsgType.CHAT: this.handleIMChat(msgObj as MqttMsg<CryptoMsg>)
                break;
                case MqttMsgType.STATUS_UPDATE: this.handleStatusUpdate(msgObj as MqttMsg<MqttBroadcast>)
                break;
            }
        } catch (err) {
            console.log(err)
            Logger.err(msg, "Msg is")
            throw Error('Mqtt msg parsing failed')
        }

    }

    registerIMChatHandler(handler: (msg:IMChat)=>void){
        this.imChatHandler = handler
    }

    private async handleIMChat(msg: MqttMsg<CryptoMsg>){

        Logger.debug("IMChat handler called")

        const cryptoString = await AppCrypto.decrypt(msg.data)
        const msgObj = JSON.parse(cryptoString.decryptedString) as IMChat

        const senderPubKey = await PubKeyManagerService.loadPubKey(msgObj.senderUid)
        if(!senderPubKey)
         throw Error('Public key of user not found')

        //verify the msg
        const verifResult = AppCrypto.verify(cryptoString.encKey, cryptoString.signature, senderPubKey!, SHA1)
        if(!verifResult)
         throw 'Sender not verified'
        
        IMChatService.handleIMChat(msgObj)
    }

    private async handleStatusUpdate(msgObj: MqttMsg<MqttBroadcast>){

        const senderPubKey = await PubKeyManagerService.loadPubKey(msgObj.data.postByUid)
        if(!senderPubKey)
         throw Error('Public key of user not found')
        
        //verify the msg
        const verifResult = AppCrypto.verify(msgObj.data.msg,msgObj.data.sign , senderPubKey!, SHA1)
        if(!verifResult)
         throw 'Sender not verified'

        IMChatService.handleIMStatus(msgObj.data)

    }
}

export default new MqttMsgHandlerService()